// extracted by mini-css-extract-plugin
module.exports = {"main-component":"upArrow_main-component__2cjQq"};